import { offer as EnUsOffer } from '../en-us/offer';
import { AgResourceLanguage } from '../types';

export const offer: AgResourceLanguage['offer'] = {
  ...EnUsOffer,
  offerPrice: {
    firstTimePurchaseIncludes: 'Le premier achat comprend:',
    free: 'Gratuit',
    total: 'Total',
    valueOfOneTimePurchase: "Valeur de l'achat unique"
  }
};
